export const TRACKING_EVENTS = {
  SESSION_START: 'session_start',
  CTA_CLICK: 'cta_click',
  TOUR_VIEW: 'tour_view',
  TOUR_TIMER_15S: 'tour_timer_15s',
  SCENE_VIEW: 'scene_view',
  SCENE_TIMER_15S: 'scene_timer_15s',
  USER_ENGAGEMENT: 'user_engagement',
  USER_ENGAGEMENT_SINGLE: 'user_engagement_single',
  SCENE_LOOKAT: 'scene_lookat',
  TOUR_LOAD_END: 'tour_load_end',
  USER_BEGIN_ENGAGEMENT: 'user_begin_engagement',
  TOUR_CONTENT_VISIBLE: 'tour_content_visible',
  TOUR_CONTENT_OPEN: 'tour_content_open',
  PAGE_VIEW: 'page_view',
  PAGE_DURATION: 'page_duration',
};
